import { Grid } from '@mui/material';
import { type ReactElement } from 'react';
import DoubleCircleChart from 'src/shared/components/Charts/CircleChart/DoubleCircleChart';
import { type CircleChartDataWrapper } from 'src/shared/types/charts';

type UsageChartsProps = {
  usageChartData?: CircleChartDataWrapper;
  chartData: CircleChartDataWrapper;
  disabled?: boolean;
  children?: ReactElement;
  isSmall?: boolean;
};

const UsageCharts = ({ chartData, disabled = false, children, isSmall = false }: UsageChartsProps) => {
  return (
    <Grid item container xs={12} md={isSmall ? 4 : 6} sx={{ flexBasis: '100% !important' }}>
      <Grid item container>
        <DoubleCircleChart chartData={chartData} disabled={disabled} />
      </Grid>
      {children}
    </Grid>
  );
};

export default UsageCharts;
